module.exports = __webpack_public_path__ + "img/deezer.6e0e8039.svg";